import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';
import { slotSpineKey } from '../../../core/constants/symbolsNames';

import { gameResourcesService } from '../../../services/gameResourcesService';

import WinLastWin from '../../../components/common/winLastWin';

const LastWinWrapper = observer(() => {
  const winCoinContainerRef = useRef(null);

  useEffect(() => {
    const spine = new Spine({ key: slotSpineKey.winCoin });
    spine.x = isMobile() ? 270 : 730;
    spine.y = isMobile() ? 55 : 685;
    winCoinContainerRef.current.addChild(spine);
    gameResourcesService.setWinCoinSpine(spine);
  }, [winCoinContainerRef]);

  return (
    <Container name='LastWinWrapperContainer'>
      <WinLastWin />
      <Container ref={winCoinContainerRef} name='WinCoinContainer' />
    </Container>
  );
});

export default LastWinWrapper;
